module.exports = __webpack_public_path__ + "img/main-2.3d35a835.svg";